import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import { StyleSheet, css } from 'lib/paypalphrodite'
import { endCPLTracking, trackImpression } from '../../lib/analytics/fpti'
import content from 'pp-react-l10n'
let i18n = content('transfer/inc/selectedFundingOption')

const styles = StyleSheet.create({
  iframe3DS: {
    '@media only screen and (max-width: 480px)': {
      width: '100%',
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
})

export class ThreeDSecureOverpanel extends React.Component {
  static propTypes = {
    selectedFundingOption: PropTypes.shape({
      contingencies: PropTypes.array,
      id: PropTypes.string,
    }),
    threeDSecureOverpanelKey: PropTypes.string,
    handle3DSSuccess: PropTypes.func,
    handle3DSFailure: PropTypes.func,
    show: PropTypes.bool,
    env: PropTypes.string,
  }

  analyticsStrings = {
    pageGroup: 'main:p2p:cards::3DS1-challenge',
    pageName: 'main:p2p:cards::3DS1-challenge',
  }

  ThreeDSAnalyticsStrings = {
    pageGroup: 'main:p2p:cards::3DS1-data',
    pageName: 'main:p2p:cards::3DS1-data',
  }
  ThreeDSSuccessAnalyticsStrings = {
    pgGrp: 'main:p2p:cards::3DS1-success',
    pgName: 'main:p2p:cards::3DS1-success',
  }
  ThreeDSFailureAnalyticsStrings = {
    pgGrp: 'main:p2p:cards::3DS1-failure',
    pgName: 'main:p2p:cards::3DS1-failure',
  }

  componentDidMount() {
    var formElement = this.refs.iFrameForm

    if (formElement) {
      formElement.submit()
    }

    const { pageGroup = '', pageName = '' } = this.analyticsStrings
    trackImpression(pageGroup, pageName, { version: '3DS1.0' })

    // The cardinal responds with a success/failure message to the iframe.
    // The iframe then posts a message to it's parent - the window.
    // (via confirm3dsSucess.dust in templates/)
    //
    // This piece of code listens to a message event on the window
    // and checks for success/failure

    // Updating the props to make sure we're calling the latest
    // prop functions on threeDS-success and threeDS-failure events.
    //
    // pay-request and buy could happen in same session, and in that case,
    // windows.threeDSProps will need to be overriden.

    window.threeDSProps = this.props

    // To prevent adding multiple listeners
    if (window.hasAdded3DSListener) {
      return null
    }

    window.addEventListener('message', e => {
      if (e.data === 'threeDS-success') {
        window.threeDSProps.handle3DSSuccess()
        const { pgGrp, pgName } = this.ThreeDSSuccessAnalyticsStrings
        trackImpression(pgGrp, pgName)
        endCPLTracking()
      } else if (e.data === 'threeDS-failure') {
        window.threeDSProps.handle3DSFailure()
        const { pgGrp, pgName } = this.ThreeDSFailureAnalyticsStrings
        trackImpression(pgGrp, pgName)
        endCPLTracking()
      }
    })

    window.hasAdded3DSListener = true
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.show) {
      var formElement = this.refs.iFrameForm

      if (formElement) {
        formElement.submit()
      }
    }
  }

  track3DSUrl(redirectURL = '', termUrl = '', paReq = '', analyticsStrings) {
    const { pageGroup = '', pageName = '' } = analyticsStrings
    trackImpression(pageGroup, pageName, { redirectURL, termUrl, paReq })
  }

  render() {
    let { contingencies = [], id } = this.props.selectedFundingOption

    if (contingencies.length <= 0) {
      return null
    }

    const contingencies3DS =
      contingencies.find(c => c.action === '3D_SECURE_AUTH_REQUIRED') || {}
    const paReq = contingencies3DS['3ds_payment_authentication_request'] || ''
    const redirectURL = contingencies3DS['3d_secure_redirect_link'] || ''
    const termUrl =
      window.location.origin +
      '/myaccount/transfer/send/3ds-contingency?x=' +
      id
    const method = contingencies3DS.cardinal_redirect_method || 'POST'
    this.track3DSUrl(redirectURL, termUrl, paReq, this.ThreeDSAnalyticsStrings)

    return (
      <div className={css(styles.textContainer)}>
        <h3>{i18n('label.threeDS')}</h3>
        <form
          target="frmLaunch"
          action={redirectURL}
          method={method}
          name="frmLaunch"
          ref="iFrameForm"
        >
          <input type="hidden" name="PaReq" value={paReq} />
          <input type="hidden" name="TermUrl" value={termUrl} />
          <input type="hidden" name="env" value={this.props.env} />
        </form>

        <iframe
          title={i18n('a11y.3ds.iframe.title')}
          className={css(styles.iframe3DS)}
          id="iframeID"
          name="frmLaunch"
          frameBorder="1"
          width="450px"
          height="450px"
          key={this.props.threeDSecureOverpanelKey}
        />
      </div>
    )
  }
}

export default connect(({ transaction, overpanels, server }) => ({
  selectedFundingOption: transaction.selectedFundingOption,
  threeDSecureOverpanelKey: overpanels.threeDSecureOverpanelKey,
  env: server.env,
}))(ThreeDSecureOverpanel)
